import { createFileRoute } from '@tanstack/react-router';

import { PendingSignOffSetsPage } from '@/features/approvals/pending-sign-off-sets.page';

export const Route = createFileRoute('/__authenticated/approvals/pending')({
	component: PendingSignOffSetsPage,
});
